import { FacilityCountries } from 'utils/types/facility';
export const showInsuranceUpsell = ({ isAirport, isEvent, country, insuranceAddon, purchaseForCustomer, isAirportInsuranceUpsellFeatureFlagEnabled, isEventInsuranceUpsellFeatureFlagEnabled, }) => {
    return Boolean(!purchaseForCustomer &&
        insuranceAddon &&
        country === FacilityCountries.US &&
        ((isAirport && isAirportInsuranceUpsellFeatureFlagEnabled) ||
            (isEvent && isEventInsuranceUpsellFeatureFlagEnabled)));
};
